import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#74d269";
function DTA({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M18.347 10.884h.015l.013 3.724L9.992 19.5l-2.244-1.262v.002l-.014-.009-2.109-1.352V7.113l2.305-1.36.004.002L9.97 4.5l8.362 4.922zm-2.456 2.334l-1.754-1.004-5.856 3.445 1.72 1.022zm-2.15-1.23L10.13 9.92l-.016 4.26zm-3.61-2.524l5.807 3.398v-2.029l-5.8-3.386zM7.74 17.676l.022-2.034-.013.008V8.472l-1.76-1.05v9.21zm.312-2.25l1.759-1.064v-6.94l-1.759 1.05zm2.16 1.523l-.034 2.127 7.826-4.602.023-2.115zm5.846-6.438l1.821-1.04-7.841-4.578-1.805 1.044z" /></Svg>;
}
DTA.DefaultColor = DefaultColor;
export default DTA;